import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Valentina, 26 años',
    text: 'Lo compré porque no sabía qué cocinar y literal me salvó. En 15 minutos ya tengo la comida lista y dejo de pensar todo el día en eso.'
  }, {
    name: 'Florencia, 32 años',
    text: 'Tenía la air fryer guardada y no la usaba casi nunca. Ahora la uso todos los días. Las recetas son simples de verdad.'
  }, {
    name: 'Sofía, 23 años',
    text: 'Me ayudó a dejar de pedir delivery en la semana. No pensé que iba a ser tan fácil organizarme.'
  }, {
    name: 'Camila, 29 años',
    text: 'Lo que más me gustó es que no son recetas complicadas. Son cosas que realmente podés hacer cuando no tenés ganas.'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-228">
      <div className="max-w-6xl mx-auto" data-id="element-229">
        <div className="text-center mb-16" data-id="element-230">
          <div className="inline-flex bg-brand-purpleLight text-brand-purpleDark px-4 py-1.5 rounded-full font-semibold text-sm mb-6" data-id="element-231">
            Lo que dicen quienes ya lo tienen
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-darkGray" data-id="element-232">
            <span className="italic text-brand-purple" data-id="element-233">Resultados reales</span>{' '}
            de personas como vos
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-234">
          {testimonials.map((t, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 border-t-4 border-t-brand-purple flex flex-col relative" data-id="element-235">
              <div className="absolute top-6 right-6 text-brand-yellow text-6xl font-serif leading-none opacity-40" data-id="element-236">
                "
              </div>
              <p className="text-brand-darkGray font-medium text-lg italic mb-8 relative z-10 flex-grow" data-id="element-237">
                "{t.text}"
              </p>
              <div className="flex items-center gap-2 mt-auto" data-id="element-238">
                <p className="font-bold text-brand-darkGray" data-id="element-239">{t.name}</p>
                <span className="text-gray-300" data-id="element-240">·</span>
                <p className="text-sm text-green-600 flex items-center gap-1 font-semibold" data-id="element-241">
                  <CheckCircle2 className="w-4 h-4" data-id="element-242" /> Clienta verificada
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}